/**
 * admin:panel-Markenzeichen — Zwischenmarke der generation:l-Familie
 * (Kunden-Wunsch 2026-09): Produkt-Signet (Tropfen) analog
 * online:academy/azubi:web, Wortmarke in Neris (klein mit Doppelpunkt,
 * Brand-Konvention der Familie). Markenfarbe = generation:l-Gruen.
 */
import { CSSProperties } from 'react';

// Markenfarbe = generation:l-Gruen (Kunden-Entscheidung 2026-09-16;
// urspruenglich Indigo #5361c9).
export const ADMINPANEL_PRIMARY = '#1cab7e';
export const ADMINPANEL_PRIMARY_DARK = '#178f69';
export const GENL_DARK = '#1f3241';

const SIGNET_D = 'M63.34,60.85c8.79-.05,16.63-4.17,21.86-10.6l-17.21-17.67c-1.88-1.95-2.84-4.48-2.84-7.03,0-5.49,4.34-9.95,9.7-9.95s9.69,4.45,9.69,9.95c0,2.55-.94,5.08-2.84,7.03l-2.05,2.22-3.21-3.27,2.11-2.17c1.02-1.07,1.53-2.42,1.53-3.8,0-2.97-2.34-5.36-5.23-5.36s-5.23,2.39-5.23,5.36c0,1.38.51,2.74,1.55,3.8l16.66,17.1c2.53-4.35,3.99-9.43,4.02-14.86V2.8c0-.44-.35-.8-.78-.8h-27.89c-15.83,0-28.67,13.17-28.67,29.42,0,5.49,1.47,10.63,4.02,15.03l16.66-17.1c1.04-1.07,1.55-2.42,1.55-3.8,0-2.97-2.34-5.36-5.23-5.36s-5.23,2.39-5.23,5.36c0,1.38.51,2.74,1.53,3.8l2.15,2.15-3.19,3.29-2.1-2.21c-1.9-1.95-2.84-4.48-2.84-7.03,0-5.49,4.34-9.95,9.69-9.95s9.7,4.45,9.7,9.95c0,2.55-.96,5.08-2.84,7.03l-17.21,17.67c5.23,6.43,13.08,10.54,21.86,10.6h.35ZM53.08,41.24l3.15-3.23,6.5,6.66c.12.12.27.18.43.18s.31-.06.43-.18l6.53-6.67,3.16,3.22-9.68,9.94c-.24.24-.62.24-.86,0l-9.66-9.92Z';

/** Tropfen-Signet, eng zugeschnitten (bbox des Pfads + etwas Luft). */
export const AdminPanelSignet = ({ color = ADMINPANEL_PRIMARY, style }: { color?: string; style?: CSSProperties }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="33 0.5 60.5 61.5" role="img" aria-label="admin:panel" style={style}>
        <path fill={color} d={SIGNET_D} />
    </svg>
);

/** Horizontale Wortmarke fuer die Top-Bar: Signet + Neris-Text. */
export const AdminPanelWordmark = ({ height = 40 }: { height?: number }) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: height * 0.25 }}>
        <AdminPanelSignet style={{ height, display: 'block' }} />
        <span style={{
            fontFamily: "Neris, 'Helvetica Neue', Arial, sans-serif",
            fontWeight: 600,
            fontSize: height * 0.62,
            lineHeight: 1,
            color: GENL_DARK,
        }}>
            admin<span style={{ color: ADMINPANEL_PRIMARY }}>:panel</span>
        </span>
    </span>
);

/** Zentrierte Variante (Login-Karte): Signet oben, Wortmarke darunter. */
export const AdminPanelMark = ({ height = 96 }: { height?: number }) => (
    <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: height * 0.1 }}>
        <AdminPanelSignet style={{ height: height * 0.62, display: 'block' }} />
        <span style={{
            fontFamily: "Neris, 'Helvetica Neue', Arial, sans-serif",
            fontWeight: 600,
            fontSize: height * 0.26,
            lineHeight: 1,
            color: GENL_DARK,
        }}>
            admin<span style={{ color: ADMINPANEL_PRIMARY }}>:panel</span>
        </span>
    </span>
);
